import { useRuntime } from '../internal';
import type { Metadata } from '../xinglet';

export function useMetadata(name: string): Metadata {
  return useRuntime().metadataMap[name];
}
